module.exports = __webpack_public_path__ + "appSharedWorker.worker.js"